import {SET_APP_CONTEXT} from '../constants';
import {SetAppContextAction} from '../index';
import {User} from './User';

export function userReducer(state: User = null, action: SetAppContextAction): User {
  switch (action.type) {
    case SET_APP_CONTEXT:
      return action.payload.user;
    default:
      return state;
  }
}
